import {createStyles} from '@mantine/core';
import React from 'react';

import {MIN_VIEWER_DIMENSION_PX} from 'molbio/molstar/util';
import MolstarViewer, {MolstarWrapperProps} from 'molbio/molstar/Viewer';

// The Mol* plugin adds no height of its own. Min height needs to be at least MIN_VIEWER_DIMENSION_PX,
// otherwise the viewer collapses and loops between the loading throbber and the plugin.
const MIN_VIEWER_HEIGHT_PX = 200;

const useStyles = createStyles(() => ({
  viewer: {
    width: '100%',
    height: '100%',
    position: 'relative',
    // Mol* only renders once the container reaches MIN_VIEWER_DIMENSION_PX in both dimensions.
    minWidth: MIN_VIEWER_DIMENSION_PX,
    minHeight: MIN_VIEWER_HEIGHT_PX,
  },
}));

interface MolstarRendererProps {
  url: string;
  format: MolstarWrapperProps['format'];
}

export default function MolstarRenderer({url, format}: MolstarRendererProps): JSX.Element {
  const {classes} = useStyles();
  return <MolstarViewer url={url} format={format} className={classes.viewer} />;
}
